import find from 'lodash/find'

import { fetchJson } from './asyncActionHelpers'
import { isValidGuid } from './actionUtil'
import {
  notifyError,
  logError,
  NOTIFY_ERROR,
  USE_BILLING_FOR_SHIPPING_TOGGLE
} from './actions'

export const ADD_SHIPPING_ADDRESS                = 'ADD_SHIPPING_ADDRESS_ACTION'
export const ADD_BILLING_ADDRESS                 = 'ADD_BILLING_ADDRESS_ACTION'
export const REMOVE_SHIPPING_ADDRESS             = 'REMOVE_SHIPPING_ADDRESS_ACTION'
export const REMOVE_BILLING_ADDRESS              = 'REMOVE_BILLING_ADDRESS_ACTION'
export const UPDATE_ADDRESS                      = 'UPDATE_ADDRESS_ACTION'
export const SELECT_BILLING_ADDRESS              = 'SELECT_BILLING_ADDRESS_ACTION'
export const SELECT_SHIPPING_ADDRESS             = 'SELECT_SHIPPING_ADDRESS_ACTION'
export const SAVE_ADDRESS_ASYNC                  = 'SAVE_ADDRESS_ASYNC_ACTION'
export const DELETE_ADDRESS_ASYNC                = 'DELETE_ADDRESS_ASYNC_ACTION'
export const SELECT_SHIPPING_AND_BILLING_ADDRESS = 'SELECT_BILLING_AND_SHIPPING_ADDRESS_ACTION'

/*
 *  SYNC ACTION CREATORS
 */

let nextAddressId = -1;

let setAddressIdIfMissing = (newAddress) => {
  if (newAddress.Id === "")
    return Object.assign({}, { Id: (nextAddressId--).toString() }, newAddress);
  else if (newAddress.Id < 0) {
    return notifyError("An error occurred trying to add the address. Please let us know!", "address already has an Id field that can be cast to a negative number");
  }
}

export function addBillingAddress(newAddress) {
  var addressWithIdOrError = setAddressIdIfMissing(newAddress);
  if (addressWithIdOrError && addressWithIdOrError.type && addressWithIdOrError.type === NOTIFY_ERROR)
    return addressWithIdOrError;
  return { type: ADD_BILLING_ADDRESS, address: addressWithIdOrError }
}

export function addShippingAddress(newAddress) {
  var addressWithIdOrError = setAddressIdIfMissing(newAddress);
  if (addressWithIdOrError && addressWithIdOrError.type && addressWithIdOrError.type === NOTIFY_ERROR)
    return addressWithIdOrError;
  return { type: ADD_SHIPPING_ADDRESS, address: addressWithIdOrError }
}

export function removeShippingAddress(addressId) {
  return { type: REMOVE_SHIPPING_ADDRESS, addressId }
}

export function removeBillingAddress(addressId) {
  return { type: REMOVE_BILLING_ADDRESS, addressId }
}

export function selectBillingAddress(addressId) {
  return { type: SELECT_BILLING_ADDRESS, addressId }
}

export function selectShippingAddress(addressId) {
  return { type: SELECT_SHIPPING_ADDRESS, addressId }
}

export function updateAddress(addressId, address) {
  return { type: UPDATE_ADDRESS, addressId, address }
}

export function selectShippingAndBillingAddress(addressId) {
  return { type: SELECT_SHIPPING_AND_BILLING_ADDRESS, addressId }
}

/*
 *  ASYNC ACTION CREATORS
 */

const onPostAddressSucceeded = (responseText, postedAddress) =>
  (isValidGuid(responseText))
  ? updateAddress(postedAddress.Id, Object.assign({}, postedAddress, { Id: responseText }))
  : notifyError('An error occurred saving an address', `Expected to receive a guid when posting an address but got: '${responseText}'`);

const saveAddressFetchSpec = {
  endpoint(state) { return state.constants.navigation.addAddressEndpoint; },
  init: { method: 'POST', credentials: 'same-origin' },
  notify(address) { return { type: SAVE_ADDRESS_ASYNC, address }; },
  extract(response) { return response.text() },
  onSuccess: onPostAddressSucceeded,
  onError(diagMsg) { return notifyError("An error occurred saving an address", diagMsg); }
};

export const saveAddress = fetchJson(saveAddressFetchSpec);

const onPostDeleteSucceeded = (responseText, { addressId }, getState) => {
  if (responseText.toUpperCase() !== "OK")
    return notifyError('An error occurred deleting an address',
      `Expected to receive 'OK' when deleting an address but got '${responseText}'`);
  else {
    const state = getState();
    const postedAddress = find(state.entities.Addresses, address => address.Id === addressId);
    if (!postedAddress)
      return logError(`No address to delete with id ${addressId}`);
    return (postedAddress.AddressType === state.constants.BillingAddressType)
      ? removeBillingAddress(postedAddress.Id)
      : removeShippingAddress(postedAddress.Id);
  }
};

const deleteAddressFetchSpec = {
  endpoint : (state) => state.constants.navigation.deleteAddressEndpoint,
  init     : { method: 'POST', credentials: 'same-origin' },
  notify   : ({ addressId }) => ( { type: DELETE_ADDRESS_ASYNC, addressId } ),
  extract  : (response) => response.text() ,
  onSuccess: onPostDeleteSucceeded,
  onError  : (diagMsg) => notifyError("An error occurred deleting an address", diagMsg)
}

export const deleteAddress = fetchJson(deleteAddressFetchSpec)